"use client";

import { isMobile } from "@/utils/helpers";
import React from "react";

interface Listing {
  standardized_description: string[];
  product: {
    brand: string;
    model: string;
  };
  product_variant: {
    size_name?: string;
    dominant_color_family: string;
    dominant_material: string;
  };
  condition_name: string;
  vendor: string;
}

interface SingleListingModalDescriptionProps {
  listing: Listing;
}

const SingleListingModalDescription: React.FC<
  SingleListingModalDescriptionProps
> = ({ listing }) => {
  const descriptionArray = listing.standardized_description;
  const textSize = isMobile() ? "text-xs" : "text-sm";

  return (
    <div className="description-container">
      <ul className={`font-raleway ${textSize} text-black font-normal break-words leading-relaxed list-disc list-inside [&>li::marker]:text-xs`}>
        {descriptionArray.map((item, index) => (
          <li key={index}>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SingleListingModalDescription;
